import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface AlertListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class AlertListPage extends Component<AlertListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.alert(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}